// extracted by mini-css-extract-plugin
export default {"Container":"Unsubscribe_Container__-aEOt","ResubscribeContainer":"Unsubscribe_ResubscribeContainer__+qxsI"};